export default {
	app: {
		debug: true,
		router: {
			meta: {
				title: "Oohdesk Auth Service",
				guard: ({ next }, { authClient }) => {
					authClient.is("logged") ? next() : next({ name: "AuthLogin" })
				}
			},
			baseUrl: "/"
		}
	},
	authClient: {
		domain: process.env.VUE_APP_PRODUCT_GENERAL_DOMAIN,
		rules: {
			guest: ({ token }) => !token,
			logged: ({ token }) => !!token,
			admin: ({ user }) => !!user.is_admin
		}
	},
	httpClient: {
		baseUrl: process.env.VUE_APP_API_HOST
	},
	userStorage: {},
	errorHandler: {}
}
